// HomeGo Removals & Packing Ltd - Canonical Company Data
// Primary branch (Burnham HQ) kept at top-level for backwards-compat across
// all existing Berkshire/Bucks location pages. Secondary branches live in
// `companyInfo.branches`. When adding new branches, append — never remove the
// HQ fields because 80+ existing pages still reference them directly.
export const companyInfo = {
  name: "HomeGo Removals & Packing Ltd",
  shortName: "HomeGo Removals",
  tagline: "Berkshire's Trusted Local Removals Company",
  registrationNumber: "16811153",
  mobile: "07440 414548",
  mobileHref: "tel:+447440414548",
  phone: "0330 043 4791",
  phoneHref: "tel:+443300434791",
  landline: "0330 043 4791",
  landlineHref: "tel:+443300434791",
  whatsapp: "https://wa.me/447440414548",
  email: "office@homego-removals.com",
  emailHref: "mailto:office@homego-removals.com",
  address: "93B Gore Road, Burnham, Slough, Berkshire SL1 7DD",
  addressLine1: "93B Gore Road, Burnham",
  addressLine2: "Slough, Berkshire SL1 7DD",
  postcode: "SL1 7DD",
  country: "United Kingdom",
  hours: "Open 24 hours a day, 7 days a week",
  hoursShort: "24/7",
  website: "https://homego-removals.com",
  logo: "/homego-logo.webp?v=2",
  logoFallback: "/homego-logo.jpg?v=2",
  geo: { lat: 51.5287, lng: -0.6395 },

  // Founder — used across About page + Complaints stage-3 escalation
  founder: {
    name: "Allah Nazar Ihsan",
    title: "Founder & Managing Director",
    directLine: "+44 7424 282046",
    directLineHref: "tel:+447424282046",
    email: "founder@homego-removals.com",
  },

  // Multi-location branches (added April 2026 — Birmingham opened)
  branches: [
    {
      key: "burnham",
      isPrimary: true,
      label: "Head Office — Burnham (Thames Valley)",
      shortLabel: "Burnham HQ",
      phone: "07440 414548",
      phoneHref: "tel:+447440414548",
      landline: "0330 043 4791",
      landlineHref: "tel:+443300434791",
      email: "office@homego-removals.com",
      emailHref: "mailto:office@homego-removals.com",
      whatsapp: "https://wa.me/447440414548",
      addressLine1: "93B Gore Road, Burnham",
      addressLine2: "Slough, Berkshire SL1 7DD",
      addressFull: "93B Gore Road, Burnham, Slough, Berkshire SL1 7DD, UK",
      postcode: "SL1 7DD",
      geo: { lat: 51.5287, lng: -0.6395 },
      areasCovered: "Berkshire, Buckinghamshire, Oxfordshire, Surrey, Hertfordshire, Hampshire, Bedfordshire, West London",
      gbpUrl: "https://maps.app.goo.gl/pekq9htnD21zK4UK6",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.7523317653113!2d-0.669258606686456!3d51.53610229915965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4633500f8d01ab37%3A0x3daa7f4327e45f47!2sHomeGo%20Removals%20%26%20Packing%20Ltd!5e0!3m2!1sen!2suk!4v1781043297365!5m2!1sen!2suk",
      opened: "2024",
    },
    {
      key: "birmingham",
      isPrimary: false,
      label: "Birmingham Branch — West Midlands",
      shortLabel: "Birmingham Branch",
      phone: "07385 150381",
      phoneHref: "tel:+447385150381",
      landline: "0121 798 0326",
      landlineHref: "tel:+441217980326",
      email: "birmingham@homego-removals.com",
      emailHref: "mailto:birmingham@homego-removals.com",
      whatsapp: "https://wa.me/447385150381",
      addressLine1: "Walford Road, Sparkbrook",
      addressLine2: "Birmingham, West Midlands B11 1NP",
      addressFull: "Walford Road, Sparkbrook, Birmingham, West Midlands B11 1NP, UK",
      postcode: "B11 1NP",
      geo: { lat: 52.4622, lng: -1.8776 },
      areasCovered: "Birmingham, Solihull, Sutton Coldfield, Walsall, Dudley, West Bromwich, Smethwick",
      gbpUrl: "https://maps.app.goo.gl/BEzgPhbdMKNWPpAY6",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.107718902092!2d-1.870638422841652!3d52.4590765720452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4870bb10570a637b%3A0x352ac1adf5f5b53b!2sHomeGo%20Removals%20Birmingham!5e0!3m2!1sen!2suk!4v1781043488333!5m2!1sen!2suk",
      opened: "April 2026",
    },
    {
      key: "uxbridge",
      isPrimary: false,
      label: "Uxbridge Branch — West London / Middlesex",
      shortLabel: "Uxbridge Branch",
      phone: "07767 975449",
      phoneHref: "tel:+447767975449",
      landline: "01753 935986",
      landlineHref: "tel:+441753935986",
      email: "uxbridge@homego-removals.com",
      emailHref: "mailto:uxbridge@homego-removals.com",
      whatsapp: "https://wa.me/447767975449",
      addressLine1: "195 Pield Heath Road",
      addressLine2: "Uxbridge, Middlesex UB8 3NR",
      addressFull: "195 Pield Heath Road, Uxbridge, Middlesex UB8 3NR, UK",
      postcode: "UB8 3NR",
      geo: { lat: 51.5358, lng: -0.4736 },
      areasCovered: "Uxbridge, Hillingdon, Ickenham, Ruislip, Eastcote, Northwood, Pinner, Cowley, West Drayton, Yiewsley, Denham, Harefield, South Ruislip, Greenford, Ruislip Manor",
      gbpUrl: "https://maps.app.goo.gl/t85itNbwHsuLPfWz7",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.2236155454516!2d-0.468311422887677!3d51.52745827181787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48766de0f6791541%3A0xacccc168bf549a42!2sHomeGo%20Removals%20Uxbridge!5e0!3m2!1sen!2suk!4v1781043373682!5m2!1sen!2suk",
      opened: "May 2026",
    },
    {
      key: "oxfordshire",
      isPrimary: false,
      label: "Oxfordshire Branch — Oxford / Thames Valley North",
      shortLabel: "Oxfordshire Branch",
      phone: "07466 625537",
      phoneHref: "tel:+447466625537",
      // No dedicated landline yet — calls route through head office until commissioned.
      landline: "",
      landlineHref: "",
      email: "oxfordshire@homego-removals.com",
      emailHref: "mailto:oxfordshire@homego-removals.com",
      whatsapp: "https://wa.me/447466625537",
      addressLine1: "6 Mandelbrook Drive, Littlemore",
      addressLine2: "Oxford, Oxfordshire OX4 4TN",
      addressFull: "6 Mandelbrook Drive, Littlemore, Oxford, Oxfordshire OX4 4TN, UK",
      postcode: "OX4 4TN",
      geo: { lat: 51.7195, lng: -1.2123 },
      areasCovered: "Oxford, Cowley, Headington, Iffley, Littlemore, Kennington, Botley, Wheatley, Abingdon, Didcot, Bicester, Witney, Banbury, Wallingford, Wantage, Thame, Henley-on-Thames, Aylesbury, High Wycombe, Reading, Newbury, Basingstoke",
      gbpUrl: "https://maps.app.goo.gl/t37agsGwoyVxQqkR8",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2471.870374895247!2d-1.2302746066261965!3d51.71711399930967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876c141c6366af1%3A0xb659b45bfbdafb75!2sHomeGo%20Removals%20Oxfordshire!5e0!3m2!1sen!2suk!4v1781043430496!5m2!1sen!2suk",
      opened: "May 2026",
    },
    {
      key: "maidenhead",
      isPrimary: false,
      label: "Maidenhead Branch — Royal Borough / Berkshire",
      shortLabel: "Maidenhead Branch",
      phone: "07440 414548",
      phoneHref: "tel:+447440414548",
      landline: "01628 369241",
      landlineHref: "tel:+441628369241",
      email: "maidenhead@homego-removals.com",
      emailHref: "mailto:maidenhead@homego-removals.com",
      whatsapp: "https://wa.me/447440414548",
      addressLine1: "39 Queen Street",
      addressLine2: "Maidenhead, Berkshire SL6 1NB",
      addressFull: "39 Queen Street, Maidenhead, Berkshire SL6 1NB, UK",
      postcode: "SL6 1NB",
      geo: { lat: 51.52178, lng: -0.72478 },
      areasCovered: "Maidenhead, Cookham, Bray, Taplow, Burnham, Windsor, Eton, Slough, Wraysbury, Datchet, Holyport, White Waltham, Cox Green, Furze Platt, Boyn Hill, Pinkneys Green, Marlow, Bourne End",
      gbpUrl: "https://maps.app.goo.gl/pvwxx9snsxXBBNiC8",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19857.86611114391!2d-0.7056499078486769!3d51.527281296320744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487663c07e08e6af%3A0xf1c3c0f8b6ccb31b!2sHomeGo%20Removals%20Maidenhead!5e0!3m2!1sen!2suk!4v1781042936370!5m2!1sen!2suk",
      opened: "February 2026",
      // Canonical URL slug used for the bespoke branch landing page.
      // Maidenhead is the only branch that lives at /removals-{key} rather than
      // /{key}-removals because the Maidenhead URL was launched as a high-SEO
      // pillar page before the branches[] structure existed.
      landingPath: "/removals-maidenhead",
    },
    {
      key: "reading",
      isPrimary: false,
      label: "Reading Branch — Thames Valley / Berkshire",
      shortLabel: "Reading Branch",
      phone: "07440 414548",
      phoneHref: "tel:+447440414548",
      landline: "0118 469 3527",
      landlineHref: "tel:+441184693527",
      email: "reading@homego-removals.com",
      emailHref: "mailto:reading@homego-removals.com",
      whatsapp: "https://wa.me/447440414548",
      addressLine1: "15 Queens Walk",
      addressLine2: "Reading, Berkshire RG1 7QF",
      addressFull: "15 Queens Walk, Reading, Berkshire RG1 7QF, UK",
      postcode: "RG1 7QF",
      geo: { lat: 51.45448, lng: -0.98094 },
      areasCovered: "Reading, Caversham, Tilehurst, Earley, Woodley, Lower Earley, Calcot, Burghfield, Theale, Pangbourne, Sonning, Twyford, Wokingham, Bracknell, Crowthorne, Wargrave, Henley-on-Thames, Goring, Streatley, Mortimer",
      gbpUrl: "https://maps.app.goo.gl/X5PrxFv9UU5uViYU6",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d79558.40453137152!2d-1.1307971027344121!3d51.454481699999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48769be8ef20a45b%3A0xf558958e4ae8b480!2sHomeGo%20Removals%20Reading!5e0!3m2!1sen!2suk!4v1781161298069!5m2!1sen!2suk",
      opened: "February 2026",
      // Reading's bespoke landing page lives at /removals-reading (same
      // convention as Maidenhead). Sub-pages nest underneath.
      landingPath: "/removals-reading",
    },
    {
      key: "miltonkeynes",
      isPrimary: false,
      label: "Milton Keynes Branch — Buckinghamshire / MK Postcodes",
      shortLabel: "Milton Keynes Branch",
      phone: "07440 414548",
      phoneHref: "tel:+447440414548",
      landline: "01908 040514",
      landlineHref: "tel:+441908040514",
      email: "miltonkeynes@homego-removals.com",
      emailHref: "mailto:miltonkeynes@homego-removals.com",
      whatsapp: "https://wa.me/447440414548",
      addressLine1: "Marlborough Gate",
      addressLine2: "Milton Keynes MK9 3XA",
      addressFull: "Marlborough Gate, Milton Keynes MK9 3XA, UK",
      postcode: "MK9 3XA",
      geo: { lat: 52.04186, lng: -0.75100 },
      areasCovered: "Milton Keynes, Central Milton Keynes (CMK), Bletchley, Wolverton, Stony Stratford, Newport Pagnell, Olney, Woburn Sands, Newton Longville, Buckingham, Leighton Buzzard, Bedford, Cranfield, Hanslope, Brackley, Northampton edge, Towcester, Aylesbury north",
      gbpUrl: "https://maps.app.goo.gl/SQpoSePFC4dZUdiB8",
      gbpShareUrl: "https://share.google/yviUxVyv1Mhpz9A5b",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2454.079700886145!2d-0.751004422862332!3d52.04186132193966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4877aa956c0ceae5%3A0xdf03df96c50c57c8!2sMarlborough%20Gate%2C%20Milton%20Keynes%20MK9%203XA!5e0!3m2!1sen!2suk!4v1782043802605!5m2!1sen!2suk",
      opened: "June 2026",
      // Milton Keynes bespoke landing page lives at /removals-milton-keynes
      // (matches the existing /removals-{branch} convention for Maidenhead and Reading).
      landingPath: "/removals-milton-keynes",
    },
    {
      key: "london",
      isPrimary: false,
      label: "London Branch — Central London / Bloomsbury",
      shortLabel: "London Branch",
      phone: "07375 033234",
      phoneHref: "tel:+447375033234",
      // No dedicated landline yet — calls route through the branch mobile.
      landline: "",
      landlineHref: "",
      email: "london@homego-removals.com",
      emailHref: "mailto:london@homego-removals.com",
      whatsapp: "https://wa.me/447375033234",
      addressLine1: "Great Russell Street",
      addressLine2: "London WC1B 3PA",
      addressFull: "Great Russell Street, London WC1B 3PA, UK",
      postcode: "WC1B 3PA",
      geo: { lat: 51.5182506, lng: -0.1260886 },
      areasCovered: "Bloomsbury, Holborn, Covent Garden, City of London, Westminster, Pimlico, Camden, Islington, King's Cross, Marylebone, Fitzrovia, Kensington, Chelsea, Notting Hill, Shoreditch, Hackney, Canary Wharf, Hampstead, Highgate, Clapham, Battersea, Fulham, Hammersmith, Greenwich and every central London postcode",
      gbpUrl: "https://maps.app.goo.gl/yW4mMzdj62aqXLQY9",
      gbpEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.7271213884733!2d-0.1259755!3d51.518222099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761bdb1992d1fd%3A0x6953e9b41198729f!2sHomeGo%20Removals%20London!5e0!3m2!1sen!2suk!4v1792593430104!5m2!1sen!2suk",
      opened: "August 2026",
      // London branch landing page follows the original /{key}-removals
      // convention (like Burnham/Birmingham/Uxbridge/Oxfordshire) because
      // /removals-london is already an established Greater-London county hub.
      landingPath: "/london-removals",
    },
  ],

  // Review / Trust
  rating: "5.0",
  reviewCount: "16",

  // Partner Backlinks (AI + SEO)
  partners: {
    trustpilot: "https://uk.trustpilot.com/review/homego-removals.com",
    // ⚠️ SET THIS to enable the live Trustpilot widget (auto-syncing star rating
    // that updates when new reviews come in). Until this is filled the site
    // falls back to a hardcoded "4.9/5" chip. Find it: log into Trustpilot
    // Business (business.trustpilot.com) → Settings → Business information →
    // scroll to "Business Unit ID" (a 24-char hex string). Paste it here.
    trustpilotBusinessUnitId: "690bfedbb056c76f02086f61",
    // Widget locale — "en-GB" for UK, "en-US" for US, etc.
    trustpilotLocale: "en-GB",
    google: "https://share.google/SuOH8SLj5htO9jfYo",
    googleReview: "https://share.google/1PupmoXGPOfsa9d81",
    checkatrade: "https://www.checkatrade.com/trades/homegoremovalspackingltd",
    getamover: "https://www.getamover.co.uk/movers/eYYNQ/homego-removals-packing-ltd/",
    yell: "https://www.yell.com/biz/homego-removals-and-packing-ltd-burnham-901234",
    sirelo: "https://sirelo.co.uk/removal-company/burnham/homego-removals-packing/",
    yably: "https://yably.co.uk/reviews/slough/homego-removals-packing-ltd-93b-gore-rd",
    yablyBadgeImage: "https://yably.co.uk/modules/custom/yably_badge/images/badge_rate_yably_2/524d1767-0355-4fe3-b9b2-c40a6178b1a9"
  },

  // Social Media
  social: {
    facebook: "https://www.facebook.com/p/Homego-Removal-61586312233331/",
    instagram: "https://www.instagram.com/homegoremovals",
    tiktok: "https://www.tiktok.com/@homegoremovals",
    youtube: "https://www.youtube.com/@HomeGoRemovals",
    x: "https://x.com/homegoremovals",
    nextdoor: "",
    whatsapp: "https://wa.me/447440414548"
  }
};

export const getBranch = (key) =>
  companyInfo.branches.find((b) => b.key === key) || companyInfo.branches[0];

export const services = [
  {
    slug: "house-removals",
    name: "House Removals",
    short: "Full home moves with care & insurance.",
    icon: "Home"
  },
  {
    slug: "office-relocation",
    name: "Office Relocation",
    short: "Business relocations with minimal downtime.",
    icon: "Building2"
  },
  {
    slug: "packing-services",
    name: "Packing Services",
    short: "Professional packing, materials included.",
    icon: "Package"
  },
  {
    slug: "furniture-assembly",
    name: "Furniture Assembly",
    short: "Dismantle & reassemble by experts.",
    icon: "Wrench"
  },
  {
    slug: "commercial-removals",
    name: "Commercial Removals",
    short: "Shops, warehouses & business moves.",
    icon: "Building2"
  }
];

/**
 * Per-page email derivation.
 *
 * Each town / county hub gets a dedicated mailbox of the form
 * `<slug>@homego-removals.com` (e.g. `slough@homego-removals.com`,
 * `reading@homego-removals.com`). This lets every SEO page surface a
 * location-specific contact email — better local-relevance signal for Google
 * and easier to attribute leads per location.
 *
 * IMPORTANT: These mailbox aliases must also be configured at the email
 * provider (Google Workspace / Microsoft 365) using a catch-all rule that
 * forwards `*@homego-removals.com` to office@homego-removals.com. Until then
 * they're SEO-only references but the catch-all approach is industry standard.
 */
export const emailForSlug = (slug) => {
  if (!slug) return "office@homego-removals.com";
  // Sanitise: lowercase, replace any non a-z0-9- with empty
  const safe = String(slug).toLowerCase().replace(/[^a-z0-9-]/g, "");
  return `${safe}@homego-removals.com`;
};

export const emailHrefForSlug = (slug) => `mailto:${emailForSlug(slug)}`;

